import { init } from '@sentry/browser';
import BUILD_VERSION from './BuildVersion';

if (process.env.NODE_ENV === 'production') {
  init({
    async beforeSend(event) {
      const isSourceLocalWebpage = event.request.url.startsWith('file://');
      if (isSourceLocalWebpage) {
        return null;
      }
      const { default: { userId } } = await import('./VcomProvider');
      if (userId !== null) {
        /* eslint-disable-next-line no-param-reassign */
        event.user = { id: `${userId}` };
      }
      return event;
    },
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
    ],
    dsn: 'https://3148081529aa444ea5139109aa25e9fa@o154513.ingest.sentry.io/1211209',
    release: BUILD_VERSION,
  });
}
